export default "__VITE_ASSET__DI2lfolH__"